import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  transform: "scale(1.33, 1.33)",
  d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
}), 'StarRateOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StarRateOutlined.js
// module id = 6471
// module chunks = 2